import { render } from "./RegistrationComponent.vue?vue&type=template&id=d56c544c&scoped=true"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js"

import "../assets/bootstrap.min.css?vue&type=style&index=0&id=d56c544c&scoped=true&lang=css"
import "./RegistrationComponent.vue?vue&type=style&index=1&id=d56c544c&scoped=true&lang=css"
import "./RegistrationComponent.vue?vue&type=style&index=2&id=d56c544c&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56c544c"]])

export default __exports__